<template>
  <div class="modal-mask">
      <div class="modal-wrapper">
       <div class="modal-dialog">
        <div class="modal-content">
         <div class="modal-body">
          <div class="d-flex">
            <div class="col-2">
              <img v-if="error" src="@/assets/images/warning.png" style="width: 50px; height: 50px;" alt="warning">
              <img v-else src="@/assets/images/success.png" style="width: 50px; height: 50px;" alt="warning">
            </div>
            <div class="col-10 text-center">
              <label class="labelMessage">
                <p v-for="parrafo in mensajeSplit" :key="parrafo">
                  {{parrafo}}
                </p>
              </label>
            </div>            
          </div>
          <br />
          <div align="center">
           <button type="button" class="btn btn-secondary btn-xs" @click="close">
             Aceptar
           </button>
          </div>
         </div>
        </div>
       </div>
      </div>
     </div>
</template>

<script>
  export default {
    name: 'Modal',
    methods: {
      close() {
        this.$emit('close');
      },
    },
    props:["mensaje", "error"],
    computed:{
      mensajeSplit(){
        return this.mensaje.split('\n');
      }
    }
  };
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.labelMessage{
  font-size: 0.9rem;
}
</style>